import { Box, InputAdornment, useTheme } from '@mui/material'
import React, { useCallback } from 'react'
import { FlagImage } from 'react-international-phone'
import CustomTextField from '../../pages/login/graphicComponents/CustomTextField'

const INDIA_DIAL_CODE = '91'

type Props = {
    value: string
    onChange: (phone: string) => void
}

export const PhoneInput: React.FC<Props> = ({ value, onChange }) => {
    const theme = useTheme()
    const inputFontSize = theme.typography.body1.fontSize

    const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const digitsOnly = event.target.value.replace(/\D/g, '').slice(0, 10)
        onChange(digitsOnly)
    }, [onChange])

    return (
        <CustomTextField
            fullWidth
            autoFocus
            placeholder="Mobile number"
            value={value}
            onChange={handleChange}
            type="tel"
            inputProps={{ inputMode: 'numeric', maxLength: 10 }}
            sx={{
                '.MuiInputBase-input': {
                    fontSize: inputFontSize,
                    fontWeight: 400,
                    paddingLeft: '2px'
                }
            }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start" sx={{ mr: 1, height: 'auto', maxHeight: 'none' }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.75,
                                pr: 1.5,
                                fontSize: inputFontSize,
                                fontWeight: 400,
                                lineHeight: 1.4375,
                                color: 'text.primary'
                            }}
                        >
                            <FlagImage size={18} iso2="in" />
                            <Box component="span">+{INDIA_DIAL_CODE}</Box>
                        </Box>
                    </InputAdornment>
                )
            }}
        />
    )
}

export const INDIA_COUNTRY_CODE = INDIA_DIAL_CODE
